import {
    Component,
    OnInit,
    EventEmitter,
    Output,
    Input,
    HostListener,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { IDateRange } from 'src/app/interfaces/date-range.interface';
import {
    EHistoryEventsFiltersMode,
    IHistoryEvents,
    IHistoryEventsFilterParams,
    IHistoryFilter,
    IHistoryFilterItem,
} from 'src/app/interfaces/history.interface';
import { LoadService } from 'src/app/services/application/load.service';
import { HistoryService } from 'src/app/services/history.service';
import { AlertService } from 'src/lib/ariadna/alert';
import {
    dateToText,
    getDayWithYear,
    getNameDay,
    getTekDay,
    getTekDayNorm,
    getTime,
    strToDate,
} from '../../application/global.function';
import { PayPeriodDialogComponent } from '../../payments/dialogs/pay-period-dialog/pay-period-dialog.component';
import { HistoryItemComponentMobile } from 'src/app/modals/history-item-mobile/history-item.component';
import { ICalendarDateActive } from 'src/app/interfaces/calendar';
import { ConfigService } from 'src/app/services/application/config.service.';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { LocationStrategy } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { HistoryPdfModal } from 'src/app/modals/history-pdf-modal/history-pdf.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SemdModalComponent } from 'src/app/modals/semd-modal/semd-modal.component';

@Component({
    selector: 'app-list-completed',
    templateUrl: './list-completed.component.html',
    styleUrls: ['./list-completed.component.scss'],
})
export class ListCompletedComponent implements OnInit {
    HistoryEvents: IHistoryEvents[] = [];
    @Output() onDateGet = new EventEmitter<ICalendarDateActive[]>(); // получил данные
    loading: boolean = false; // Загрузка талонов
    showFilials = true; // Показ филиалов в таблице/фильтре. Параметр из АРМ
    // gridTemplateColumns = '9.5rem 1fr 9.5rem 1fr 1fr 4rem';
    gridTemplateColumns = 'repeat(7, 1fr)';
    _selectDate: string = ''; // выбранная дата

    @Input() CountRecPage: number = 10;
    @Input() filterChecked: boolean = false;
    @Output() filterCheckedChange = new EventEmitter<boolean>();

    CountRec: number = 0; // Всего записей
    CurentPage: number = 1; // Текущая сраница

    historyPages: Array<IHistoryEvents[]> = [];
    date: IDateRange = { dt_begin: null, dt_end: null };

    loadedPages = 1;
    viewPage = 0;
    periodText = 'За всё время';
    countOfPages = 0;
    historyListLength: number = 0; // Количество записей
    countRecToPage = 10; // Количетсво записей на странице
    loadingMoreContent = false;
    pdfLoader = false;
    isMobile: boolean = false;

    filters: Record<'spec' | 'doc' | 'dep', IHistoryFilter> = {
        spec: {
            list: [] as IHistoryFilterItem[],
            mode: EHistoryEventsFiltersMode.SPEC,
            selectedID: null,
            searchText: '',
            loading: false,
        },
        doc: {
            list: [] as IHistoryFilterItem[],
            mode: EHistoryEventsFiltersMode.DOC,
            selectedID: null,
            searchText: '',
            loading: false,
        },
        dep: {
            list: [] as IHistoryFilterItem[],
            mode: EHistoryEventsFiltersMode.DEP,
            selectedID: null,
            searchText: '',
            loading: false,
        },
    };
    originalData: Record<'spec' | 'doc' | 'dep', IHistoryFilter> = {
        spec: {} as IHistoryFilter,
        doc: {} as IHistoryFilter,
        dep: {} as IHistoryFilter,
    };

    private resizeHandler = () => {
        this.isMobile = window.innerWidth <= 767;

        this.cdr.detectChanges();
    };

    constructor(
        private router: Router,
        private hs: HistoryService,
        private dialog: MatDialog,
        private configS: ConfigService,
        private load: LoadService,
        private historyService: HistoryService,
        private alert: AlertService,
        private http: HttpNewService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
    ) {
        // this.date = { dt_begin: new Date(), dt_end: new Date() };
        // Promise.all([this.getHistoryFilters, this.getHistorySize]).then(() =>
        //     this.changedPage(1)
        // );

        this.showFilials = Boolean(load.configData.pages.history.showFilials);
        if (!this.showFilials)
            // this.gridTemplateColumns = '9.5rem 1fr 9.5rem 1fr 9rem 1fr';
            this.gridTemplateColumns = '1fr 23.5rem 1fr 1fr 1fr 1fr';
    }

    async ngOnInit(): Promise<void> {
        moment.locale('ru');
        this.periodText = this.getPeriodText(this.date);
        this.isMobile = window.innerWidth <= 767;
        // if (!this.isMobile) {
        this.loading = true;
        this.loadingMoreContent = true;
        // }

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 767;
            this.cdr.detectChanges();
        });
        window.addEventListener('scroll', () => this.onScroll());

        try {
            await this.getHistorySize(); // Получаем общее количество записей
            // if (!this.isMobile) {
            await this.loadInitialData(); // Загружаем первую страницу данных
            // }
            this.getHistoryFilters(); // Загружаем фильтры
            this.isInitialLoadComplete = true;
        } catch (error) {
            console.error('Error initializing component:', error);
        } finally {
            // this.loading = false;
            this.loadingMoreContent = false;
            this.cdr.detectChanges();
        }

        this.formatDateToString(this.date);
    }

    private async loadInitialData(): Promise<void> {
        if (this.isMobile) {
            await this.loadMoreHistory(1, this.countRecToPage);
        } else {
            await this.getListHistory(1, this.CountRecPage);
        }
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => this.onScroll());
        window.removeEventListener('resize', this.resizeHandler);
    }

    @ViewChild('#visitsContainer')
    visitsContainer!: ElementRef;
    @HostListener('document:click', ['$event'])
    @HostListener('window:scroll', ['$event'])
    private scrollTimeout: any = null;
    isInitialLoadComplete: boolean = false;

    onScroll() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            const visitsContainer = document.querySelector(
                '.list-completed-desktop__visits',
            );
            if (!visitsContainer) return;

            const lastVisitCard = visitsContainer.querySelector(
                '.visits__card:last-child',
            );
            if (!lastVisitCard) return;

            const rect = lastVisitCard.getBoundingClientRect();
            const windowHeight =
                window.innerHeight || document.documentElement.clientHeight;

            const isLastCardVisible =
                rect.bottom <= windowHeight &&
                rect.bottom > 0 &&
                this.loadedPages < this.countOfPages;

            if (isLastCardVisible && this.viewPage < this.CountRec) {
                this.loadNextPage();
            }
        }, 200);
    }

    async getListHistory(pStart: number, pEnd: number): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                // Выполняем запрос с уже загруженными фильтрами
                this.fetchListHistory(pStart, pEnd, resolve, reject);
            } catch (error) {
                console.error('Error loading history filters:', error);
                this.alert.error('Не удалось загрузить фильтры', 3000);
                reject(error);
            }
        });
    }

    isBlockYeer(index: number): boolean {
        if (index === 0) return true;

        return (
            this.HistoryEvents.length >= index + 1 &&
            this.HistoryEvents[index].dtSort.getFullYear() !==
                this.HistoryEvents[index - 1].dtSort.getFullYear()
        );
    }

    getYeer(index: number): string {
        if (this.HistoryEvents && this.HistoryEvents[index]) {
            return this.HistoryEvents[index].dtSort.getFullYear() + '';
        } else {
            return '';
        }
    }

    getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    getTime(dt: Date): string {
        return getTime(dt);
    }

    /* Смена страницы */
    changedPage(page: number) {
        this.CurentPage = page;

        if (page === 1) {
            this.getListHistory(1, this.CountRecPage);
        } else {
            this.getListHistory(
                page * this.CountRecPage - this.CountRecPage + 1,
                page * this.CountRecPage,
            );
        }
    }

    // Formats
    getTextDoc(doc: string) {
        const arr = doc.trim().split(' ');
        const [lastname, firstname, ...patronymParts] = doc.trim().split(' ');
        return `${lastname} ${firstname?.length ? firstname[0] + '.' : ''} ${
            patronymParts.join('').length ? patronymParts.join('')[0] + '' : ''
        }`;
    }
    getDoctorName(doc: string) {
        if (!doc) return '';

        const parts = doc.trim().split(' ');
        if (parts.length < 2) return doc;

        const [lastname, firstname, secondname] = parts;
        return `${lastname || ''} ${firstname || ''} ${
            secondname || ''
        }`.trim();
    }

    async loadNextPage() {
        // Проверяем условия для загрузки следующей страницы
        if (
            this.loadedPages / this.countOfPages !== 1 &&
            !this.loadingMoreContent
        ) {
            try {
                // Устанавливаем флаг загрузки

                if (this.isMobile) {
                    // Мобильная версия
                    this.loadingMoreContent = true;
                    await this.loadMoreHistory(
                        this.loadedPages * this.countRecToPage -
                            this.countRecToPage +
                            1,
                        this.loadedPages * this.countRecToPage,
                    );
                    // setTimeout(() => {
                    this.viewPage++;
                    this.loadingMoreContent = false;
                    // }, 100);
                } else {
                    this.loadingMoreContent = true;
                    // Десктоп версия
                    const nextPage = this.CurentPage + 1;
                    const currentItems = [...this.HistoryEvents];

                    await this.getListHistory(
                        nextPage * this.CountRecPage - this.CountRecPage + 1,
                        nextPage * this.CountRecPage,
                    );

                    // Добавляем новые элементы к существующим
                    this.HistoryEvents = [
                        ...currentItems,
                        ...this.HistoryEvents,
                    ];

                    this.CurentPage = nextPage;
                }

                this.loadedPages++;

                // Сбрасываем флаг загрузки
                this.loadingMoreContent = false;

                this.cdr.detectChanges();
            } catch (error) {
                console.error('Error loading next page:', error);

                // В случае ошибки
                this.loadingMoreContent = false;

                // Показываем уведомление об ошибке
                this.alert.error('Не удалось загрузить данные', 3000);

                this.cdr.detectChanges();
            }
        }
    }

    /** Изменение периода для вывода записей*/
    async changePeriod(dt: IDateRange): Promise<void> {
        this.loadingMoreContent = true;
        this.date = dt;
        this.historyPages = [];
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.viewPage = 1;
        this.pStart = 1;
        this.pEnd = this.countRecToPage;
        this.countOfPages = 0;
        try {
            await this.getHistorySize();
            await this.getHistoryFilters();
            this.formatDateToString(this.date);
            this.periodText = this.getPeriodText(this.date);

            // Загружаем только первую страницу
            await this.loadMoreHistory(this.pStart, this.pEnd);
        } finally {
            this.loadingMoreContent = false;
            this.cdr.detectChanges();
        }
    }

    async getHistoryFilters(): Promise<void> {
        // Устанавливаем флаги загрузки
        this.filters.spec.loading = true;
        this.filters.doc.loading = true;
        this.filters.dep.loading = true;

        try {
            // Параллельная загрузка фильтров
            const filterPromises = [
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        begin_dat: null,
                        end_dat: null,
                        mode: EHistoryEventsFiltersMode.SPEC,
                    }),
                ),
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        begin_dat: null,
                        end_dat: null,
                        mode: EHistoryEventsFiltersMode.DOC,
                    }),
                ),
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        begin_dat: null,
                        end_dat: null,
                        mode: EHistoryEventsFiltersMode.DEP,
                    }),
                ),
            ];

            const [specData, docData, depData] =
                await Promise.all(filterPromises);

            // Обновляем фильтры
            this.filters.spec.list = specData;
            this.filters.doc.list = docData;
            this.filters.dep.list = depData;

            // Сбрасываем флаги загрузки
            this.filters.spec.loading = false;
            this.filters.doc.loading = false;
            this.filters.dep.loading = false;

            // Сохраняем оригинальные данные
            this.originalData = JSON.parse(JSON.stringify(this.filters));
        } catch (error) {
            console.error('Ошибка загрузки фильтров:', error);

            // Сбрасываем флаги загрузки
            this.filters.spec.loading = false;
            this.filters.doc.loading = false;
            this.filters.dep.loading = false;

            // Показываем уведомление об ошибке
            this.alert.error('Не удалось загрузить фильтры', 3000);

            // Генерируем исключение для обработки в вызывающем коде
            throw error;
        }
    }

    // getSizeHistory(dt: Date | null) {
    //     this.loading = true;

    //     this.hs
    //         .getHistoryEventsSize({
    //             beginDate: dt,
    //             endDate: dt,
    //             specID: this.filters.spec.selectedID,
    //             docID: this.filters.doc.selectedID,
    //             depID: this.filters.dep.selectedID,
    //         })
    //         .subscribe(
    //             (res) => {
    //                 if (res && res.size > 0) {
    //                     this.CountRec = res.size;
    //                     this.changedPage(1);
    //                 } else {
    //                     this.onDateGet.emit([]);
    //                     this.loading = false;
    //                 }
    //             },
    //             (err) => {
    //                 this.loading = false;
    //             }
    //         );
    // }

    async getHistorySize() {
        try {
            const [resHistory] = await Promise.all([
                await lastValueFrom(
                    this.hs.getHistoryEventsSize({
                        beginDate: this.date.dt_begin,
                        endDate: this.date.dt_end,
                        specID: this.filters.spec.selectedID,
                        docID: this.filters.doc.selectedID,
                        depID: this.filters.dep.selectedID,
                    }),
                ),
            ]);

            this.CountRec = resHistory.size;
            this.CountRec;

            this.setCountOfPagesMobile();
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка услуг');
        }
    }
    pStart: number = 1;
    pEnd: number = 10;
    loadedPagesMobile: number = 0;

    get HistoryItems(): IHistoryEvents[] {
        return this.historyPages.flat();
    }
    /** Подгрузка дополнительного кал-ва услуг */
    async loadMoreHistory(pStart?: number, pEnd?: number) {
        // if (!this.isInitialLoadComplete || !pStart || !pEnd) return;

        try {
            this.loadingMoreContent = true;
            const res = await lastValueFrom(
                this.historyService.getHistoryEvents(
                    this.date.dt_begin,
                    this.date.dt_end,
                    pStart,
                    pEnd,
                    this.filters.spec.selectedID,
                    this.filters.doc.selectedID,
                    this.filters.dep.selectedID,
                ),
            );

            res.forEach((item) => {
                item.dtSort = new Date(
                    item.dat.replace(/(\d+).(\d+).(\d+)/, '$3/$2/$1'),
                );
            });

            // Проверка на уникальность
            const existingIds = new Set(
                this.historyPages.flat().map((item) => item.keyid),
            );
            const filteredRes = res.filter(
                (item) => !existingIds.has(item.keyid),
            );

            if (filteredRes.length > 0) {
                this.historyPages.push(filteredRes);
                this.pStart += 10;
                this.pEnd += 10;
                this.loadedPagesMobile++;
                this.viewPage++;
                this.loadedPages++;
            } else {
                this.countOfPages = this.loadedPagesMobile;
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка посещений');
            throw error;
        } finally {
            this.loadingMoreContent = false;
            this.loading = false;
            this.cdr.detectChanges();
        }
    }

    private fetchListHistory(
        pStart: number,
        pEnd: number,
        resolve: () => void,
        reject: (error: any) => void,
    ) {
        try {
            // this.loading = true;
            let dtHistory: Date | null = null;
            if (this._selectDate && this._selectDate.length > 4) {
                dtHistory = moment(this._selectDate, 'YYYY-MM-DD').toDate();
            }

            this.hs
                .getHistoryEvents(
                    dtHistory,
                    dtHistory,
                    pStart,
                    pEnd,
                    this.filters.spec.selectedID,
                    this.filters.doc.selectedID,
                    this.filters.dep.selectedID,
                )
                .subscribe({
                    next: (res) => {
                        try {
                            this.HistoryEvents = res;
                            let dt: ICalendarDateActive[] = [];

                            this.HistoryEvents.forEach((item) => {
                                item.dtSort = strToDate(item.dat);
                                dt.push({
                                    date: Number(
                                        moment(item.dtSort).format('YYYYMMDD'),
                                    ),
                                });
                            });

                            if (!dtHistory) {
                                this.onDateGet.emit(dt);
                            }
                            resolve();
                        } catch (processingError) {
                            console.error(
                                'Error processing history events:',
                                processingError,
                            );
                            reject(processingError);
                        }
                    },
                    error: (err) => {
                        console.error('Error fetching history events:', err);
                        this.alert.error('Не удалось загрузить историю', 3000);
                        reject(err);
                    },
                    complete: () => {
                        this.loading = false;
                        this.cdr.detectChanges();
                    },
                });
        } catch (error) {
            console.error('Unexpected error in fetchListHistory:', error);
            this.loading = false;
            this.alert.error(
                'Непредвиденная ошибка при загрузке истории',
                3000,
            );
            reject(error);
            this.cdr.detectChanges();
        }
    }

    /**
     * Фильтрация записей по дате

     */
    btnFilterByDay(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            });
        } else {
            this.changePeriod({ dt_begin: null, dt_end: null });
        }
    }

    // /** Получение дня недели */
    // getNameDay(dt: Date): string {
    //     return getNameDay(dt);
    // }

    // getTekDay(dt: Date): string {
    //     return getTekDay(dt);
    // }

    getTekDayNorm(dt: Date): string {
        return getTekDayNorm(dt);
    }

    /** Получение времени формата "D MM YYYY" */
    getDayWithYear(dtSort: Date) {
        return getDayWithYear(dtSort);
    }

    // /** Получение времени формата "HH:mm" */
    // getTime(dt: Date): string {
    //     return getTime(dt);
    // }

    /** Получение периода текстом в формате "D MMM YYYY"*/
    formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = moment(new Date(dt.dt_begin)).format('D MMM YYYY');
        }
        if (dt.dt_end) {
            dt.str_end = moment(new Date(dt.dt_end)).format('D MMM YYYY');
        }
    }

    /** Установка количества страниц*/
    setCountOfPagesMobile() {
        this.countOfPages = Math.ceil(this.CountRec / this.countRecToPage);
        this.viewPage = 0;
    }

    /** Вызов диалога для выбора периода */
    showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                } as IDateRange,
            },
        });

        periodDialog.afterClosed().subscribe((result: any) => {
            if (result?.date) {
                this.loading = true;
                this.changePeriod(result.date).then(
                    () => (this.loading = false),
                );
            }
        });
    }

    /** Вызов диалога с деталями услуги */
    showDetailsDialog(history: IHistoryEvents) {
        if (history.has_semd && history.has_semd > 0) {
            return lastValueFrom(
                this.http.get(
                    `/history/events/item/semd?tp=${history.typehistory}&id=${history.keyid}&isNeedPdf=0&sort=0`,
                ),
            )
                .then((pdf) => {
                    const safeHtml = [];
                    for (const part of pdf) {
                        safeHtml.push(
                            this.sanitizer.bypassSecurityTrustHtml(part),
                        );
                    }
                    const modal = this.modalService.open(SemdModalComponent, {
                        size: 'large',
                    });
                    modal.componentInstance.data = safeHtml;
                    this.pdfLoading = false;
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {});
        }
        const dialogRef = this.dialog.open(HistoryItemComponentMobile, {
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            closeOnNavigation: true,
            data: history,
        });

        return dialogRef.afterOpened().subscribe(() => {
            const dialogContent = document.querySelector(
                '.cdk-global-overlay-wrapper',
            ) as HTMLElement;
            if (dialogContent) {
                dialogContent.style.alignItems = 'unset';
            }
            // dialogContent.style;
            // dialogContent.style.overflowY = 'auto';
            // dialogContent.style.maxHeight = 'calc(100vh - 120px)'; // Adjust the value according to your needs
        });
    }
    /** Полученеи текста из периода */
    getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin === dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'За всё время';
            else if (dt.dt_begin?.toDateString() === new Date().toDateString())
                periodText = 'Последние посещения';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.str_begin && dt.str_end) {
            periodText = `${dt.str_begin} - ${dt.str_end}`;
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }

        return periodText;
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */
    btnFilterByDate(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.loading = true;
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            }).then(() => (this.loading = false));
        } else {
            this.date.dt_begin = null;
            this.date.dt_end = null;
            this.loading = true;
            this.changePeriod({ dt_begin: null, dt_end: null }).then(() => {
                this.loading = false;
            });
        }
    }
    get isAnyFilterActive(): boolean {
        return (
            this.filters.spec.selectedID !== null ||
            this.filters.doc.selectedID !== null ||
            this.filters.dep.selectedID !== null
        );
    }

    // Основная функция обработки изменения фильтров
    onChangeFilter(
        id: number | null,
        mode: EHistoryEventsFiltersMode,
        event?: Event,
    ) {
        if (event) {
            event.stopPropagation();
        }

        // Обновляем текст поиска выбранным значением
        switch (mode) {
            case EHistoryEventsFiltersMode.SPEC:
                if (id !== null) {
                    const selectedSpec = this.filters.spec.list.find(
                        (spec) => spec.keyid === id,
                    );
                    if (selectedSpec) {
                        this.filters.spec.searchText = selectedSpec.text;
                    }
                } else {
                    this.filters.spec.searchText = '';
                }
                this.handleSpecialtyFilterChange(id);
                break;

            case EHistoryEventsFiltersMode.DOC:
                if (id !== null) {
                    const selectedDoc = this.filters.doc.list.find(
                        (doc) => doc.keyid === id,
                    );
                    if (selectedDoc) {
                        this.filters.doc.searchText = selectedDoc.text;
                    }
                } else {
                    this.filters.doc.searchText = '';
                }
                this.handleDoctorFilterChange(id);
                break;

            case EHistoryEventsFiltersMode.DEP:
                if (id !== null) {
                    const selectedDep = this.filters.dep.list.find(
                        (dep) => dep.keyid === id,
                    );
                    if (selectedDep) {
                        this.filters.dep.searchText = selectedDep.text;
                    }
                } else {
                    this.filters.dep.searchText = '';
                }
                this.handleDepartmentFilterChange(id);
                break;
        }

        this.loading = true;
        this.historyPages = []; // Очищаем страницы
        this.viewPage = 0;
        this.loadedPages = 0;
        this.pStart = 1;
        this.pEnd = 10;

        // Закрываем все dropdown
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
        this.isDepDropdownOpen = false;

        // Существующая логика загрузки
        this.getHistorySize()
            .then(() => {
                if (this.isMobile) {
                    this.loadMoreHistory(1, this.countRecToPage);
                } else {
                    this.changedPage(1);
                }
            })
            .catch((error) => {
                console.error('Error loading history:', error);
                this.loading = false;
            });
    }

    // Обработка изменения фильтра специальности
    private handleSpecialtyFilterChange(id: number | null): void {
        this.filters.spec.selectedID = id;

        // Проверка наличия spec_id в списке докторов и филиалов
        const hasSpecId = this.filters.doc.list.some(
            (item) => item.spec_id !== undefined,
        );

        const hasDepId = this.filters.dep.list.some(
            (item) => item.spec_id !== undefined,
        );

        if (!hasSpecId) {
            // Если spec_id отсутствует, фильтруем HistoryEvents
            if (id !== null) {
                this.HistoryEvents = this.HistoryEvents.filter(
                    (event) => event.keyid === id,
                );
            } else {
                // Восстановление исходного списка
                this.getListHistory(1, this.CountRecPage);
            }
        } else {
            // фильтруем списки врачей и филиалов
            if (id) {
                this.filterDoctorsBySpecialty(id);
                if (hasDepId) {
                    this.filterDepartmentsByDoctors();
                }
            } else {
                this.resetDoctorsList();
                this.handleSelectedDoctor();
            }
        }
    }

    // Фильтрация докторов по выбранной специальности
    private filterDoctorsBySpecialty(specialtyId: number): void {
        this.filters.doc.list = this.filters.doc.list.filter((item) => {
            if (item.spec_id) {
                const specIds = item?.spec_id
                    .split(',')
                    .map((s: string) => s.trim());
                return specIds.some(
                    (specId: string) => Number(specId) === specialtyId,
                );
            }
        });
    }

    // Фильтрация отделений на основе отфильтрованных докторов
    private filterDepartmentsByDoctors(): void {
        const filteredDocDepIds = new Set<string>();
        this.filters.doc.list.forEach((doc) => {
            if (doc?.dep_id) {
                doc.dep_id.split(',').forEach((depId: string) => {
                    filteredDocDepIds.add(depId.trim());
                });
            }
        });

        this.filters.dep.list = this.filters.dep.list.filter((item) =>
            filteredDocDepIds.has(String(item.keyid)),
        );
    }

    // Восстановление исходного списка докторов
    private resetDoctorsList(): void {
        this.filters.doc.list = this.originalData.doc.list;
    }

    // Обработка выбранного доктора при сбросе других фильтров
    private handleSelectedDoctor(): void {
        if (this.filters.doc.selectedID !== null) {
            const selectedDocIndex = this.filters.doc.list.findIndex(
                (doc) => doc.keyid === this.filters.doc.selectedID,
            );

            if (selectedDocIndex > -1) {
                const selectedDoc = this.filters.doc.list[selectedDocIndex];
                this.filters.doc.list.splice(selectedDocIndex, 1);
                this.filters.doc.list.unshift(selectedDoc);

                this.filterDepartmentsBySelectedDoctor(selectedDoc);
            } else {
                this.filters.dep.list = this.originalData.dep.list;
            }
        } else {
            this.filters.dep.list = this.originalData.dep.list;
        }
    }

    // Фильтрация отделений по выбранному доктору
    private filterDepartmentsBySelectedDoctor(doctor: any): void {
        if (!doctor?.dep_id) {
            this.filters.dep.list = [];
            return;
        }

        const depIds = doctor.dep_id.split(',').map((id: string) => id.trim());

        this.filters.dep.list = this.originalData.dep.list.filter((item) => {
            if (!item.keyid) return false;
            return depIds.includes(String(item.keyid));
        });
    }

    // Обработка изменения фильтра доктора
    private handleDoctorFilterChange(id: number | null): void {
        this.filters.doc.selectedID = id;

        // Проверка наличия spec_id в списке специальностей и филиалов
        const hasSpecId = this.filters.spec.list.some(
            (item) => item.spec_id !== undefined,
        );

        const hasDepId = this.filters.dep.list.some(
            (item) => item.spec_id !== undefined,
        );

        if (!hasSpecId) {
            // Если spec_id отсутствует, фильтруем HistoryEvents
            if (id !== null) {
                this.HistoryEvents = this.HistoryEvents.filter(
                    (event) => event.keyid === id,
                );
            } else {
                // Восстановление исходного списка
                this.getListHistory(1, this.CountRecPage);
            }
        } else {
            // Существующая логика фильтрации с использованием spec_id
            if (id) {
                const selectedDoc = this.filters.doc.list.find(
                    (item) => item.keyid === id,
                );

                if (selectedDoc) {
                    this.filterSpecialtiesByDoctor(selectedDoc);
                    if (hasDepId) {
                        this.filterDepartmentsBySelectedDoctor(selectedDoc);
                    }
                }
            } else {
                this.resetSpecialtiesList();
                this.resetDepartmentsList();
            }
        }
    }

    // Фильтрация специальностей по выбранному доктору
    private filterSpecialtiesByDoctor(doctor: any): void {
        if (!doctor?.spec_id) {
            this.filters.spec.list = [];
            return;
        }

        const docSpecIds = doctor.spec_id
            .split(',')
            .map((s: string) => Number(s.trim()));

        this.filters.spec.list = this.originalData.spec.list.filter((item) =>
            docSpecIds.includes(item.keyid),
        );
    }

    // Восстановление исходного списка специальностей
    private resetSpecialtiesList(): void {
        this.filters.spec.list = this.originalData.spec.list;
    }

    // Восстановление исходного списка отделений
    private resetDepartmentsList(): void {
        this.filters.dep.list = this.originalData.dep.list;
    }

    // Обработка изменения фильтра отделения

    private handleDepartmentFilterChange(id: number | null): void {
        this.filters.dep.selectedID = id;

        // Проверка наличия spec_id в списках докторов и специальностей()
        const hasDepId = this.filters.doc.list.some(
            (item) => item.spec_id !== undefined,
        );

        const hasSpecId = this.filters.spec.list.some(
            (item) => item.spec_id !== undefined,
        );

        if (!hasDepId) {
            // Если dep_id отсутствует, фильтруем HistoryEvents
            if (id !== null) {
                this.HistoryEvents = this.HistoryEvents.filter(
                    (event) => event.keyid === id,
                );
            } else {
                // Восстановление исходного списка
                this.getListHistory(1, this.CountRecPage);
            }
        } else {
            if (id) {
                this.filterDoctorsByDepartment(id);
                if (hasSpecId) {
                    this.filterSpecialtiesByFilteredDoctors();
                }
                this.moveSelectedDoctorToTop();
            } else {
                this.resetDoctorsList();
                this.resetSpecialtiesList();
                this.moveSelectedDoctorToTop();
            }
        }
    }

    // Фильтрация докторов по выбранному отделению
    private filterDoctorsByDepartment(departmentId: number): void {
        this.filters.doc.list = this.originalData.doc.list.filter((item) => {
            if (!item?.dep_id) return false;

            const depIds = item.dep_id
                .split(',')
                .map((depId: string) => depId.trim());
            return depIds.includes(String(departmentId));
        });
    }
    // Фильтрация специальностей на основе отфильтрованных докторов
    private filterSpecialtiesByFilteredDoctors(): void {
        const specIds = new Set<number>();
        this.filters.doc.list.forEach((doc) => {
            if (doc?.spec_id) {
                doc.spec_id.split(',').forEach((specId: string) => {
                    specIds.add(Number(specId.trim()));
                });
            }
        });

        this.filters.spec.list = this.originalData.spec.list.filter((item) =>
            specIds.has(item.keyid),
        );
    }

    // Перемещение выбранного доктора в начало списка
    private moveSelectedDoctorToTop(): void {
        if (this.filters.doc.selectedID !== null) {
            const selectedDocIndex = this.filters.doc.list.findIndex(
                (doc) => doc.keyid === this.filters.doc.selectedID,
            );

            if (selectedDocIndex > -1) {
                const selectedDoc = this.filters.doc.list[selectedDocIndex];
                this.filters.doc.list.splice(selectedDocIndex, 1);
                this.filters.doc.list.unshift(selectedDoc);
            }
        }
    }

    // Fires by press "ENTER" or click cross(clear)
    async onSearchFilter(mode: EHistoryEventsFiltersMode, event: Event) {
        event.stopPropagation();
        const elem = event.target as HTMLInputElement;
        if (elem.value) return; // Skip "ENTER"

        await this.onChangeFilter(null, mode);
    }
    pdfLoading: boolean = false;

    // async gotToDownload(
    //     id: number,
    //     tp: string,
    //     $event: MouseEvent,
    //     has_semd = 0,
    // ) {
    //     $event.stopPropagation();
    //     this.pdfLoading = true;
    //     console.log(has_semd);
    //     if (has_semd && has_semd > 0) {
    //         const res: string = await lastValueFrom(
    //             this.http.get(
    //                 `/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=1&sort=0`,
    //             ),
    //         );
    //         this.pdfLoading = false;
    //         return this.printPdf(res);
    //     }
    //     const statePdf: number =
    //         this.load.configData.pages.history.PDFButtonState ?? 0;
    //     let statePdfFull: number = statePdf ? 1 : 0;
    //     switch (statePdfFull) {
    //         case 1:
    //             try {
    //                 const res = await lastValueFrom(
    //                     this.http.get(
    //                         `/history/events/item/visitpdf/${tp}/${id}`,
    //                         null,
    //                         false,
    //                     ),
    //                 );
    //                 this.dialog.open(HistoryPdfModal, {
    //                     width: 'auto',
    //                     height: 'auto',
    //                     closeOnNavigation: true,
    //                     data: res,
    //                 });
    //                 this.pdfLoading = false;
    //             } catch (e) {
    //                 this.alert.error('Ошибка загрузки');
    //                 this.pdfLoading = false;
    //             }
    //             break;
    //         default:
    //             try {
    //                 const res:
    //                     | string
    //                     | { text: string; link_or_html_flag: string } =
    //                     await lastValueFrom(
    //                         this.http.get(
    //                             this.getDownloadUrlForPDF(id, tp),
    //                             null,
    //                             false,
    //                         ),
    //                     );
    //                 if (
    //                     typeof res === 'object' &&
    //                     res.link_or_html_flag === 'link'
    //                 ) {
    //                     lastValueFrom(
    //                         this.http.post(
    //                             '/history/events/visit/api',
    //                             { url: res.text },
    //                             true,
    //                         ),
    //                     )
    //                         .then((pdf) => {
    //                             return this.printPdf(pdf);
    //                         })
    //                         .catch((err) => {
    //                             this.alert.error(`Ошибка ${err.message}`);
    //                         });
    //                 } else {
    //                     return this.printPdf(res as string);
    //                 }
    //             } catch (error) {
    //                 console.log(error);
    //                 this.alert.error('Ошибка загрузки');
    //             } finally {
    //                 this.pdfLoading = false;
    //             }
    //     }
    // }
    async gotToDownload(
        id: number,
        tp: string,
        $event: MouseEvent,
        has_semd = 0,
    ) {
        $event.stopPropagation();
        this.pdfLoading = true;

        // Синхронно создаём iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.setAttribute(
            'sandbox',
            'allow-same-origin allow-scripts allow-downloads',
        );
        document.body.appendChild(iframe);

        let cleaned = false;
        const cleanup = () => {
            if (!cleaned) {
                cleaned = true;
                setTimeout(() => {
                    if (iframe.parentNode) {
                        document.body.removeChild(iframe);
                    }
                }, 2000);
            }
        };

        try {
            let blob: string;

            if (has_semd && has_semd > 0) {
                blob = await lastValueFrom(
                    this.http.get(
                        `/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=1&sort=0`,
                    ),
                );
            } else {
                const statePdf: number =
                    this.load.configData.pages.history.PDFButtonState ?? 0;
                const statePdfFull: number = statePdf ? 1 : 0;

                if (statePdfFull === 1) {
                    const res = await lastValueFrom(
                        this.http.get(
                            `/history/events/item/visitpdf/${tp}/${id}`,
                            null,
                            false,
                        ),
                    );
                    cleanup();
                    this.dialog.open(HistoryPdfModal, {
                        width: 'auto',
                        height: 'auto',
                        closeOnNavigation: true,
                        data: res,
                    });
                    this.pdfLoading = false;
                    return;
                } else {
                    const res = await lastValueFrom(
                        this.http.get(
                            this.getDownloadUrlForPDF(id, tp),
                            null,
                            false,
                        ),
                    );
                    if (
                        typeof res === 'object' &&
                        res.link_or_html_flag === 'link'
                    ) {
                        const pdf = await lastValueFrom(
                            this.http.post(
                                '/history/events/visit/api',
                                { url: res.text },
                                true,
                            ),
                        );
                        blob = pdf;
                    } else {
                        blob = res as string;
                    }
                }
            }

            // Подставляем blob в iframe на скачивание
            const cleanBase64 = blob.replace(
                /^data:application\/pdf;base64,/,
                '',
            );
            const iframeDoc =
                iframe.contentDocument || iframe.contentWindow?.document;
            iframeDoc?.write(`
            <html>
                <body>
                    <a id="dl" 
                       href="data:application/pdf;base64,${cleanBase64}" 
                       download="document.pdf">
                    </a>
                    <script>
                        document.getElementById('dl').click();
                    </script>
                </body>
            </html>
        `);
            iframeDoc?.close();

            cleanup();
        } catch (error) {
            cleanup();
            console.log(error);
            this.alert.error('Ошибка загрузки');
        } finally {
            this.pdfLoading = false;
        }
    }
    getDownloadUrlForPDF(id: number, tp: string) {
        return `/history/events/item/${tp}/${id}.pdf`;
    }

    resetFilters() {
        // Сбрасываем все фильтры до их исходного состояния
        this.filters.spec.list = [...this.originalData.spec.list];
        this.filters.doc.list = [...this.originalData.doc.list];
        this.filters.dep.list = [...this.originalData.dep.list];

        // Сбрасываем выбранные ID и поисковые тексты
        this.filters.spec.selectedID = null;
        this.filters.doc.selectedID = null;
        this.filters.dep.selectedID = null;

        this.filters.spec.searchText = '';
        this.filters.doc.searchText = '';
        this.filters.dep.searchText = '';

        // Сообщаем, что фильтры неактивны родительскому компоненту
        this.filterCheckedChange.emit(false);

        // Очищаем массивы с данными
        this.HistoryEvents = [];
        this.historyPages = new Array<IHistoryEvents[]>();

        // Полностью сбрасываем переменные пагинации
        this.viewPage = 0;
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.pStart = 1;
        this.pEnd = 10;
        this.CurentPage = 1;

        // Пересчитываем количество страниц и загружаем данные
        this.loading = true;

        // Сначала получаем общее количество записей
        this.getHistorySize()
            .then(() => {
                // Затем загружаем первую страницу данных
                if (this.isMobile) {
                    // this.loadMoreHistory(1, this.countRecToPage);
                    this.getListHistory(1, this.CountRecPage);
                } else {
                }
                this.cdr.detectChanges();
            })
            .finally(() => {
                this.loading = false;
                this.cdr.detectChanges();
            });
    }

    applyFilters() {
        const hasActiveFilter =
            this.filters.spec.selectedID !== null ||
            this.filters.doc.selectedID !== null ||
            this.filters.dep.selectedID !== null;

        this.filterChecked = false;
        this.filterCheckedChange.emit(hasActiveFilter);
        this.loading = false;
        this.viewPage = 0;
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.pStart = 1;
        this.pEnd = 10;
        this.CurentPage = 0;
        this.CountRec = 0;
        this.setCountOfPagesMobile();
        this.historyPages = [];
        this.getHistorySize();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        // this.closeDropdown(event);
    }
    isSpecDropdownOpen = false;
    isDocDropdownOpen = false;
    isDepDropdownOpen = false;

    toggleSpecDropdown(event: Event) {
        event.stopPropagation(); // Остановка всплытия события
        this.isSpecDropdownOpen = !this.isSpecDropdownOpen;
        this.isDocDropdownOpen = false;
        this.isDepDropdownOpen = false;
    }

    toggleDocDropdown(event: Event) {
        event.stopPropagation();
        this.isDocDropdownOpen = !this.isDocDropdownOpen;
        this.isSpecDropdownOpen = false;
        this.isDepDropdownOpen = false;
    }

    toggleDepDropdown(event: Event) {
        event.stopPropagation();
        this.isDepDropdownOpen = !this.isDepDropdownOpen;
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent) {
        const clickedInside =
            event.target instanceof HTMLElement &&
            (event.target.closest('.custom-input') ||
                event.target.closest('.custom-dropdown'));

        if (!clickedInside) {
            this.isSpecDropdownOpen = false;
            this.isDocDropdownOpen = false;
            this.isDepDropdownOpen = false;
        }
    }
    closeFilter(): void {
        this.filterChecked = false;
        this.filterCheckedChange.emit(false);
    }

    private printPdf(blob: string): void {
        const cleanBase64 = blob.replace(/^data:application\/pdf;base64,/, '');
        const binaryString = atob(cleanBase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const file = new Blob([bytes], {
            type: 'application/pdf',
            endings: 'native',
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.type = 'application/pdf';
        link.download = 'document.pdf';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(fileURL), 60_000);
    }
}
